import { Button } from "antd";
import { useMemo } from "react";
import { openPause } from ".";
import { useTrackingOp } from "../../../../contexts/TrackingOpContext";
import { getPauseState } from "../../../../util/varibles/global";
import { TOperation2 } from "../../../../util/varibles/interface";

export default function PauseButton({ data }: { data: TOperation2 }) {
    const [start, set] = useTrackingOp(state => state.op?.activity_log[0].real_start_time);

    const { state, limitStart, activePauseIndex } = useMemo(() => getPauseState(data), [data]);

    const handleClick = () => {
        if (state === -1)
            return;
        openPause({
            limitStart: Math.max(start || 0, limitStart),
            data,
            state,
            activeIndex: activePauseIndex,
            onSave: (value) => {
                set({ op: value, pause: !state ? (value.operation.pauses?.length || 0) - 1 : -1 })
            }
        })
    }

    return <Button disabled={state === -1} className="bt-primary" onClick={handleClick}>
        {state === 1 ? "Resume" : "Pause"}
    </Button>
}